module.exports = __webpack_public_path__ + "img/back_01.d54958af.png";